import React from "react";
import PropTypes from "prop-types";
import Button from "wonderbly-components/lib/Button";
import "./AddToCart.scss";

export const AddToCartForm = (props) => (
  <form className="add-to-cart-form">
    <Button
      type="submit"
      disabled={props.isDisabled}
      onClick={props.handleSubmit}
      fullWidth
    >
      {props.cta}
    </Button>
  </form>
);

const AddToCart = (props) => (
  <section className="add-to-cart">
    <div className="container-guttered">
      <AddToCartForm {...props} />
    </div>
  </section>
);

AddToCartForm.propTypes = {
  productId: PropTypes.string.isRequired,
  isDisabled: PropTypes.bool,
  handleSubmit: PropTypes.func,
  cta: PropTypes.string,
};

export default AddToCart;
